"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var remove_accents_1 = __importDefault(require("remove-accents"));
var constants_1 = require("./Grid/constants");
var utils_1 = require("./Grid/utils");
var is_equal_1 = __importDefault(require("date-fns/is_equal"));
var is_before_1 = __importDefault(require("date-fns/is_before"));
var is_after_1 = __importDefault(require("date-fns/is_after"));
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var Grid_1 = __importDefault(require("./Grid"));
var applySort = lodash_1.curry(function (sortFn, sort, items) {
    if (sortFn) {
        return sortFn(items, sort);
    }
    if (sort != null) {
        return lodash_1.sortBy(items, function (item) { return item[sort]; });
    }
    else {
        return items;
    }
});
var applyOrder = lodash_1.curry(function (order, items) {
    if (order === constants_1.Order.DESC) {
        return lodash_1.reverse(items);
    }
    else {
        return items;
    }
});
var applyPaging = lodash_1.curry(function (page, pageSize, items) {
    // paging
    var start = Math.min(page * pageSize, items.length);
    var end = Math.min((page + 1) * pageSize, items.length);
    return lodash_1.slice(items, start, end);
});
var isDateCol = function (type) { return type === constants_1.ColumnType.DATETIME || type === constants_1.ColumnType.Date; };
var filterEq = function (v1, v2, column) { return (isDateCol(column.type) ? is_equal_1.default(v1, v2) : v1 === v2); };
var filterNeq = function (v1, v2, column) { return (isDateCol(column.type) ? !is_equal_1.default(v1, v2) : v1 !== v2); };
var filterStartWith = function (v1, v2) { return v1.startsWith(v2); };
var filterEndWith = function (v1, v2) { return v1.endsWith(v2); };
var filterContain = function (v1, v2) { return v1.includes(v2); };
var filterLt = function (v1, v2, column) { return (isDateCol(column.type) ? is_before_1.default(v1, v2) : v1 < v2); };
var filterGt = function (v1, v2, column) { return (isDateCol(column.type) ? is_after_1.default(v1, v2) : v1 > v2); };
var filterLte = function (v1, v2, column) { return (isDateCol(column.type) ? is_before_1.default(v1, v2) || is_equal_1.default(v1, v2) : v1 <= v2); };
var filterGte = function (v1, v2, column) { return (isDateCol(column.type) ? is_after_1.default(v1, v2) || is_equal_1.default(v1, v2) : v1 >= v2); };
var filterValue = lodash_1.curry(function (field, operation, asciiValue, column, item) {
    var itemValue = item[field];
    var itemAsciiValue = itemValue != null ? remove_accents_1.default(String(itemValue).toLowerCase()) : null;
    if (operation === constants_1.FilterOperation.EQ) {
        return filterEq(itemAsciiValue, asciiValue, column);
    }
    else if (operation === constants_1.FilterOperation.STARTWITH) {
        return filterStartWith(itemAsciiValue, asciiValue);
    }
    else if (operation === constants_1.FilterOperation.ENDWITH) {
        return filterEndWith(itemAsciiValue, asciiValue);
    }
    else if (operation === constants_1.FilterOperation.NEQ) {
        return filterNeq(itemAsciiValue, asciiValue, column);
    }
    else if (operation === constants_1.FilterOperation.CONTAINS) {
        return filterContain(itemAsciiValue, asciiValue);
    }
    else if (operation === constants_1.FilterOperation.LT) {
        return filterLt(itemAsciiValue, asciiValue, column);
    }
    else if (operation === constants_1.FilterOperation.LTE) {
        return filterLte(itemAsciiValue, asciiValue, column);
    }
    else if (operation === constants_1.FilterOperation.GT) {
        return filterGt(itemAsciiValue, asciiValue, column);
    }
    else if (operation === constants_1.FilterOperation.GTE) {
        return filterGte(itemAsciiValue, asciiValue, column);
    }
    else {
        return true;
    }
});
var applyFilter = lodash_1.curry(function (columns, items, filter) {
    var field = filter.field, operation = filter.operation, value = filter.value;
    var asciiValue = value != null ? remove_accents_1.default(String(value).toLowerCase()) : null;
    if (field == null || operation == null) {
        return items;
    }
    // find column by value from Select field
    var column = columns.find(function (c) { return c.field === field; });
    return items.filter(filterValue(field, operation, asciiValue, column));
});
var applyFilters = lodash_1.curry(function (filters, columns, items) {
    return filters.reduce(applyFilter(columns), items);
});
var applyUniversalFilter = lodash_1.curry(function (universalFilter, columns, items) {
    return universalFilter
        ? items.filter(function (item) {
            return lodash_1.find(columns, function (column) {
                return column.type === constants_1.ColumnType.TEXT || column.type === constants_1.ColumnType.TEXT_NUMBER
                    ? filterValue(column.field, constants_1.FilterOperation.CONTAINS, universalFilter, column, item)
                    : false;
            });
        })
        : items;
});
var applyGroupping = lodash_1.curry(function (groupping, group, items) {
    if (groupping && group) {
        var fn_1 = group.mapper || lodash_1.identity;
        return lodash_1.uniqBy(items, function (i) { return fn_1(i[group.field]); });
    }
    return items;
});
var groupRowFormat = function (item, getItems, group) {
    var children = getItems(item);
    return " (" + children.length + ")";
};
var constructItems = function (_a) {
    var pageSize = _a.pageSize, page = _a.page, sort = _a.sort, order = _a.order, filters = _a.filters, value = _a.value, columns = _a.columns, grouping = _a.grouping, group = _a.group, openedGroups = _a.openedGroups, sortFn = _a.sortFn, enableUniversalFilter = _a.enableUniversalFilter, universalFilter = _a.universalFilter;
    // prettier-ignore
    var items = recompose_1.compose(applyFilters(filters, columns), applyUniversalFilter(enableUniversalFilter ? universalFilter : undefined, columns), applyOrder(order), applySort(sortFn, sort))(value);
    var count = items.length;
    var withGroupping = applyGroupping(grouping, group, items);
    var withPagination = applyPaging(page, pageSize, withGroupping);
    return {
        items: withPagination,
        count: count,
        groupRowFormat: groupRowFormat,
        getGroupItems: function (it) {
            if (grouping && group) {
                var fn_2 = group.mapper || lodash_1.identity;
                var groupItems = items.filter(function (i) { return lodash_1.isEqual(fn_2(i[group.field]), fn_2(it[group.field])); });
                return groupItems;
            }
            return [];
        },
    };
};
var ComposedLocalGrid = recompose_1.compose(recompose_1.setDisplayName('LocalGrid'), recompose_1.defaultProps({
    pageSizeItems: [
        { id: 10, label: '10' },
        { id: 20, label: '20' },
        { id: 50, label: '50' },
        { id: 100, label: '100' },
        { id: 1000, label: '1000' },
    ],
    sort: null,
    order: constants_1.Order.DESC,
    pageSize: 10,
    page: 0,
    columns: [],
    filters: [],
    checkedItems: [],
    openedGroups: [],
    version: null,
}), utils_1.persistencePropsLoader, utils_1.gridStateManager, recompose_1.withProps(constructItems))(Grid_1.default);
exports.default = ComposedLocalGrid;
exports.FormLocalGrid = reduxFormWrappers_1.formWrapper(ComposedLocalGrid);
//# sourceMappingURL=LocalGrid.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/LocalGrid.js
// module id = 2550
// module chunks = 0